const state = {
    openedTabList: [{name:'用户列表,user list', componentName: 'User'}],
    activeTab: '',
}

const mutations = {
    ADD_TABLE(state, data) {
        state.openedTabList = state.openedTabList.concat(data)
    },
    CHANGE_TABLE(state, data) {
        state.activeTab = data
    },
    DELETE_TABLE(state, data) {
        let newData = Object.assign(state.openedTabList)
        let indexs = 0
        newData.forEach((item, index, self) => {
            if (item.componentName == data) {
                indexs = index
            }
        })
        newData.splice(indexs, 1)
        Object.assign({}, state.openedTabList, newData)
    },
}

const actions = {
    addTable({commit}, data) {
        commit('ADD_TABLE', data)
    },
    changeTable({commit}, data) {
        commit('CHANGE_TABLE', data)
    },
    deleteTable({commit}, data) {
        commit('DELETE_TABLE', data)
    }

}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
